import type { MetabaseDashboard } from "@/types/shared";
import { IS_PRODUCTION } from "@/constants/app.constants";

type EnvDashboardId = { prod: number; dev: number };

const DASHBOARD_IDS = {
  patientFunnel: { prod: 664, dev: 35 },
  campaignPerformance: { prod: 663, dev: 67 },
  coordinatorPerformance: { prod: 662, dev: 100 },
  koraPerformance: { prod: 661, dev: 133 },
} satisfies Record<string, EnvDashboardId>;

const resolveId = ({ prod, dev }: EnvDashboardId) =>
  IS_PRODUCTION ? prod : dev;

/**
 * Needs for i18next-scanner
 */
// t('Patient Funnel')
// t('Campaign Performance')
// t('Coordinator Performance')
// t('Kora Performance')
// t("Monitor your clinic's pre-appointment performance")
// t('Monitor your lead sources and campaign performance')
// t('Monitor your coordinator team performance')
// t('Monitor Kora agent performance')

export const dashboards: MetabaseDashboard[] = [
  {
    label: "Patient Funnel",
    description: "Monitor your clinic's pre-appointment performance",
    id: resolveId(DASHBOARD_IDS.patientFunnel),
  },
  {
    label: "Campaign Performance",
    description: "Monitor your lead sources and campaign performance",
    id: resolveId(DASHBOARD_IDS.campaignPerformance),
  },
  {
    label: "Coordinator Performance",
    description: "Monitor your coordinator team performance",
    id: resolveId(DASHBOARD_IDS.coordinatorPerformance),
  },
  {
    label: "Kora Performance",
    description: "Monitor Kora agent performance",
    id: resolveId(DASHBOARD_IDS.koraPerformance),
  },
];
